/**
 * Message entity schema
 */

import { z } from 'zod';
import { MessageRoleSchema } from '../enums';

export const MessageSchema = z.object({
  id: z.string(),
  world_id: z.string(),
  role: MessageRoleSchema,
  content: z.string(),
  token_count: z.number().int().nullable().optional(),
  inference_log_id: z.string().nullable().optional(),
  chapter_id: z.string().nullable().optional(),
  archived_to_r2: z.union([z.literal(0), z.literal(1)]).optional(),
  created_at: z.string(),
});

export type Message = z.infer<typeof MessageSchema>;
